/** @format */

import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import moment from 'jalali-moment';

import Master from '../Layouts/Master';
import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';

const TicketInbox = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [tickets, setTickets] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    fetchTickets();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const fetchTickets = async () => {
    setLoading(true);
    await useApi.get(
      `/panel/tickets/inbox${search}`,
      {},
      (res) => {
        setTickets(res.data?.data ?? []);
        setMeta(res.data?.meta ?? null);
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('دریافت صندوق ورودی با خطا مواجه شد');
      }
    );
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Master>
      <div className="d-flex flex-row align-items-center border-bottom pb-3 my-3">
        <i className="fad fa-inbox f-20 text-secondary mx-2"></i>
        <h1 className="text-secondary f-14 font-weight-bold mb-0">صندوق ورودی تیکت‌ها</h1>
      </div>

      {tickets.length === 0 ? (
        <div className="card border shadow-sm">
          <div className="card-body text-center py-5 text-muted f-14">
            تیکتی برای بررسی وجود ندارد.
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>موضوع</th>
                <th>کاربر</th>
                <th>کد ملی</th>
                <th>وضعیت</th>
                <th>آخرین بروزرسانی</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tickets.map((ticket) => (
                <tr key={ticket.id}>
                  <td>{ticket.id}</td>
                  <td>{ticket.subject}</td>
                  <td>{ticket.user?.name ?? '—'}</td>
                  <td>{ticket.user?.national_card_id ?? '—'}</td>
                  <td>
                    <span
                      className={`badge ${
                        ticket.status === 'closed' ? 'badge-secondary' : 'badge-warning'
                      }`}
                    >
                      {ticket.status_label}
                    </span>
                  </td>
                  <td>
                    {moment(ticket.last_reply_at ?? ticket.created_at)
                      .locale('fa')
                      .format('YYYY/MM/DD HH:mm')}
                  </td>
                  <td>
                    <Link
                      to={`/panel/tickets/${ticket.id}`}
                      className="btn btn-sm btn-primary"
                    >
                      پاسخ
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {(meta?.last_page ?? 1) > 1 && (
        <div className="w-100 mt-4 d-flex">
          <Pagination
            totalPage={meta?.last_page ?? 1}
            basePath="/panel/tickets/inbox"
          />
        </div>
      )}
    </Master>
  );
};

export default TicketInbox;
